import { render } from "./component-num.vue?vue&type=template&id=4e67aee9"
import script from "./component-num.vue?vue&type=script&setup=true&lang=js"
export * from "./component-num.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-num.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e67aee9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e67aee9', __exports__)) {
    api.reload('4e67aee9', __exports__)
  }
  
  module.hot.accept("./component-num.vue?vue&type=template&id=4e67aee9", () => {
    api.rerender('4e67aee9', render)
  })

}


export default __exports__